<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{$t($route.meta.title)}}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add
                                @invoke-method="invokeMethod($event)"
                                action="showProductionLine"
                                perm="configuration.create"
                            ></bc-btn-add>
                            <bc-btn-refresh
                                @invoke-method="dbGetProductionLines()"
                            ></bc-btn-refresh>
                            <bc-search-menu
                                :params="axiosParams"

                            >
                                <v-list>
                                    <v-list-tile class="mb-3">
                                        <bc-search-input
                                            v-model="filter.search"
                                            :params="axiosParams"
                                        ></bc-search-input>
                                    </v-list-tile>

                                    <v-divider></v-divider>

                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav
                                @invoke-method="invokeMethod($event)"
                                :mobile-list="mobile_list"
                            ></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table
                        :headers="headers"
                        :items="production_lines"
                        :no-data-text="$t('lang.no_results_matching')"
                        hide-actions
                        :class="{ 'prevent-click': !hasPerm('configuration.update') }"
                    >
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="showProductionLine(props.item)">
								<td>{{ props.item.production_line }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination
                        :page="page"
                        :params="axiosParams"
                        name="settings_production_lines"
                    ></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="production_line_dialog">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ currObjField('line_id') ? $t('lang.edit_production_line') : $t('lang.add_production_line') }}</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            action="closeProductionLineDialog"
                            :dialog-status="production_line_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="production_lines" @submit.prevent>
                            <v-container grid-list-form>
                                <v-layout row wrap>
									<v-flex xs12>
										<v-text-field
											v-focus="production_line_dialog"
											v-model="production_line.production_line"
											:label="`${$t('lang.production_line')} *`"
											:counter="showCounter(production_line.production_line, 'production_lines.production_line')"
											:rules="ifValid('production_lines.production_line')"
										></v-text-field>
									</v-flex>

                                </v-layout>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn v-if="currObjField('line_id') && hasPerm('configuration.delete')" color="error" @mouseup.left="$refs.delete_production_lines.openDialog()">{{ $t('lang.delete') }}</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="closeProductionLineDialog()">{{$t('lang.cancel')}}</v-btn>
                        <v-btn color="success" @mouseup.left="modifyProductionLine(currObjField('line_id') ? 'patch' : 'post', currObjField('line_id'))">{{$t('lang.save')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_production_lines"
                :heading="$t('lang.delete_production_line')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="modifyProductionLine('delete', currObjField('line_id'))"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            headers: [{ text: this.$t("lang.production_line"), sortable: false, width: "100%" }],
            production_line: {
                production_line: "",
            },
            current_obj: null,
            filter: {
                search: "",
                page_size: 0,
                page_num: 0,
            },
            production_line_dialog: false,
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "showProductionLine", perms: ["configuration.create"] },
                { title: this.$t("lang.refresh"), action: "dbGetProductionLines" },
            ],
            dbGetProductionLines: _.debounce(this.getProductionLines, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchProduction", {
                url: "production_lines",
                method: "get",
                stateProperty: "production_lines",
                commit: true,
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.production_lines) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.$store
            .dispatch("fetchProduction", {
                url: "production_lines",
                method: "get",
                stateProperty: "production_lines",
                commit: true,
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.production_lines) {
                    this.setQuery(parsedQuery, this.filter, this.default_filter);
                    this.finishLoader();
                    next();
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    computed: {
        ...mapState({
            rules_production_lines: (state) => state.validation.rules_production_lines,
            default_filter: (state) => state.production.production_lines_filter,
            page: (state) => state.production.page,
            production_lines: (state) => state.production.production_lines,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
        currObjField() {
            return (field) => {
                return this.current_obj && field && this.current_obj[field] ? this.current_obj[field] : "";
            };
        },
    },
    methods: {
        closeProductionLineDialog() {
            this.production_line_dialog = false;
            this.$refs.delete_production_lines.close();
            this.$store.commit("validationOff");
            this.$store.commit("toggleModalLoader", false);
        },
        getProductionLines() {
            this.startLoader();
            this.$store
                .dispatch("fetchProduction", {
                    url: "production_lines",
                    method: "get",
                    stateProperty: "production_lines",
                    commit: true,
                    body: JSON.parse(JSON.stringify(this.$route.query)),
                })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.production_line_dialog = false;
                    this.$store.commit("toggleModalLoader", false);
                    this.$store.commit("validationOff");
                    this.finishLoader(true);
                });
        },
        modifyProductionLine(method = null, id = null) {
            if (method) {
                this.$store.commit("validationOn");
                this.$nextTick(() => {
                    if (method == "delete" || this.validateForm("production_lines")) {
                        this.$store.commit("toggleModalLoader", true);
                        this.$store
                            .dispatch("fetchProduction", {
                                pk: "line_id",
                                id: id,
                                url: `production_lines/${id ? id : ""}`,
                                method: method,
                                stateProperty: "production_lines",
                                mutate: true,
                                body: this.production_line,
                            })
                            .then((data) => {
                                if (data && data.code == "200") {
                                    this.closeProductionLineDialog();
                                } else {
                                    this.$store.commit("toggleModalLoader", false);
                                }
                            });
                    }
                });
            }
        },
        showProductionLine(item = null) {
            this.current_obj = item;

            if (this.$refs.production_lines) item ? this.$refs.production_lines.resetValidation() : this.$refs.production_lines.reset();

            this.$nextTick(() => {
                this.assignObj(this.production_line, item, this.rules_production_lines);
                this.production_line_dialog = true;
            });
        },
    },
};
</script>
